import { axios } from '@/utils/request'

const api = {
  sellerRewardSetting: '/badminapi/business/sellerRewardSetting',
  getSellerRewardSetting: '/badminapi/business/getSellerRewardSetting',
  businessSetting: '/badminapi/business/businessSetting',
  getBusinessSetting: '/badminapi/business/getBusinessSetting',
  getBusinessUserList: '/badminapi/business/businessUserList',
  addBusinessUser: '/badminapi/business/addBusinessUser',
  deleteBusinessUser: '/badminapi/business/deleteBusinessUser',
  cateTreeList: '/badminapi/business/cateTreeList',
}

export default api

export function getCateTreeList(parameter) {
  return axios({
    url: api.cateTreeList,
    method: 'get',
    params: parameter
  })
}

export function sellerRewardSetting(parameter) {
  return axios({
    url: api.sellerRewardSetting,
    method: 'post',
    data: parameter
  })
}
export function getSellerRewardSetting(parameter) {
  return axios({
    url: api.getSellerRewardSetting,
    method: 'post',
    data: parameter
  })
}
export function businessSetting(parameter) {
  return axios({
    url: api.businessSetting,
    method: 'post',
    data: parameter
  })
}
export function getBusinessSetting(parameter) {
  return axios({
    url: api.getBusinessSetting,
    method: 'post',
    data: parameter
  })
}
export function getBusinessUserList(parameter) {
  return axios({
    url: api.getBusinessUserList,
    method: 'post',
    data: parameter
  })
}
export function deleteBusinessUser(parameter) {
  return axios({
    url: api.deleteBusinessUser,
    method: 'post',
    data: parameter
  })
}
export function addBusinessUser(parameter) {
  return axios({
    url: api.addBusinessUser,
    method: 'post',
    data: parameter
  })
}
 